import React from 'react'
import ProductVariantPrice from '../ProductVariantPrice'
import { ProductPriceRangeType, OutOfStockStatusEnum } from '../../../../generated/gqlTypes'
import { useTranslation } from 'react-i18next'

interface IProps {
  sku: string
  properties: {
    id: number
    attributeName: string
    valueName: string
  }[]
  quantity: number
  variant: {
    priceRange: ProductPriceRangeType
    stockQuantity: number
    shippingRequired: boolean
    outOfStockStatus: string
    isSupply: boolean
    stockStatus: OutOfStockStatusEnum | null
  } | null
}

const VariantSimple: React.FC<IProps> = ({ sku, properties, quantity, variant }) => {
  const { t } = useTranslation()
  return (
    <div>
      <ProductVariantPrice quantity={1} selectedVariant={variant} showStatus={false} />
      <div className='-mt-10'>
        <div className='line-clamp-2'>
          <span className='font-semibold'>{t('sku', 'SKU')}: </span>
          <span>{sku}</span>
        </div>
        <div>
          {properties.map(prop => {
            return (
              <div key={prop.id}>
                <span className='font-semibold'>{prop.attributeName}: </span>
                <span>{prop.valueName}</span>
              </div>
            )
          })}
        </div>
        <div>
          <span className='font-semibold'>{t('quantity', 'Quantity')}: </span>
          <span>{quantity}</span>
        </div>
      </div>
    </div>
  )
}

export default VariantSimple
